import { useSelector } from "react-redux";

export default function useProtectedRoutes() {
  const {
    user: { info },
  } = useSelector((state) => state.profile);

  return {
    role: info.roles[0]?.name,
    has_team: info.has_team,
  };
}
